<template>
  <div>
    <el-table :data="wageSlips" tooltip-effect="dark" border stripe height="calc(100vh - 115px)" v-loading="loading">
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>

      <el-table-column label="工资状态" width="100">
        <template #default="{row}">
            <el-tag v-if="row.status==0" type="info">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else-if="row.status==1">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else-if="row.status==2" type="danger">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else-if="row.status==3" type="warning">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else-if="row.status==4" type="danger">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else-if="row.status==5">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else-if="row.status==6" type="success">{{ statusEnumMap[row.status] }}</el-tag>
            <el-tag v-else type="info">{{ statusEnumMap[row.status] }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column v-for="(column, index) in tableColumns2" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
      </el-table-column>

      <el-table-column label="操作" width="80" fixed="right">
        <template #="{row}">
          <el-button type="text" @click="toInfo(row)">明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <wage-info v-model="wageInfoVisible" :wageSlip="wageSlip" />
  </div>
</template>

<script>
import { getSilpEnumAll } from '@/api';
import { getWageByUserId } from '@/api/sys/user'
import { defineComponent } from 'vue'
import WageInfo from './WageInfo.vue'

export default defineComponent({
  components: { WageInfo },
  props: {
    userId: String,
    currColumnValue: Number
  },
  data() {
    return {
      isInit: false, // 是否初始化
      wageInfoVisible: false, // 工资详情显示
      wageSlip: {}, // 工资
      wageSlips: [], // 工资列表
      loading: false,
      statusEnumMap: {}, // 工资状态枚举
      tableColumns: [
        { type: 'index', width: 55, label: '序号', fixed: 'left' },
        { prop: 'salaryMonth', label: '月份', width: 90, fixed: 'left' }
      ],
      tableColumns2: [
        { prop: 'bankName', label: '银行名称', minWidth: 100, tooltip: true },
        { prop: 'bankDeposit', label: '开户行', minWidth: 100, tooltip: true },
        { prop: 'bankCardNo', label: '银行卡号', minWidth: 200 },
        { prop: 'isAbnormal', label: '是否异常', width: 90, formatter: (row) => row.isAbnormal ? '是' : '否' },
        { prop: 'shouldPaySalary', label: '应发工资', width: 150 },
        { prop: 'socialAccountDeduction', label: '社保扣除', width: 150 },
        { prop: 'individualIncomeTax', label: '个税扣除', width: 150 },
        { prop: 'otherDeduction', label: '其他扣除', width: 100 },
        { prop: 'actualSalary', label: '实发金额', width: 100 }
      ]
    };
  },
  methods: {
    getData() {
      this.loading = true;
      getWageByUserId(this.userId).then(({data}) => {
        this.wageSlips = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    toInfo(wageSlip) {
      this.wageSlip = wageSlip;
      this.wageInfoVisible = true;
    },
    //获取所有工资状态枚举值
    querySilpEnum(){
      getSilpEnumAll().then(({data})=>{
        this.statusEnumMap = data.data;
        this.isInit = true;
      })
    },
  },
  watch: {
    currColumnValue(val) {
      if (val === 3) {
        this.getData();
        if (!this.isInit) {
          this.querySilpEnum();
        }
      }
    }
  }
})
</script>
